import {
    AttributeClientModel,
    AttributeHeadersModel,
    AttributeModel,
    AttributeTypesModel
} from "@/views/loyalty/models/attribute.model"

export class AttributeService {
    constructor (data) {
        this.attribute = data || Object.create({}, AttributeModel)
    }

    get item () {
        return Object.assign(this.attribute, this.typeHuman, this.deletedHuman)
    }

    get deletedHuman () {
        const text = this.attribute.deleted ? 'Да' : 'Нет'
        return { deletedHuman: text }
    }

    get typeHuman () {
        const text = AttributeTypesModel.find(f => f.value === this.attribute.type).text
        return { typeHuman: text }
    }

    static getHeaders () {
        return AttributeHeadersModel
    }

    static getTypes () {
        return AttributeTypesModel
    }
}

export class AttributeClientService {
    _makeAttributeClientModel (data) {
        if (Object.is(data, Object)) {
            const arr = Object.entries(data).filter(f => f[0] === 'attributeId' || f[0] === 'clientId')
            return Object.fromEntries(arr)
        } else {
            return data
        }
    }

    constructor (data) {
        this.obj = data || Object.create({}, AttributeClientModel)
        this.obj = Object.assign(this.obj, { value: '' })
    }

    get item () {
        return this.obj
    }

    // get Html () {
    //     switch (this.obj.type) {
    //         case 0:
    //             return `<input type="text" name="${this.obj.name}" >`
    //             default:
    //                 return '<span></span>'
    //     }
    // }
}
